import React, { useEffect, useState } from"react";
import axios from"axios";
import API_BASE_URL from"../Config/config";

const SuperPayments = () => {
 const [payments, setPayments] = useState([]);

 useEffect(() => {
 axios.get(`${API_BASE_URL}/superadmin/payments`)
 .then(res => setPayments(res.data))
 .catch(err => console.error(err));
 }, []);

 const exportCSV = () => {
 window.open(`${API_BASE_URL}/superadmin/payments/export`,"_blank");
 };

 return (
 <div className="p-8 bg-bgMain min-h-screen">
 <div className="flex justify-between items-center mb-10">
   <div>
     <h1 className="text-4xl font-black text-heading tracking-tight mb-2">Financial Records</h1>
     <p className="text-muted font-medium">Monitor and export all platform transactions.</p>
   </div>
   <button onClick={exportCSV} className="flex items-center gap-2 bg-brand-gradient text-white px-8 py-3 rounded-2xl font-bold shadow-lg shadow-primary/20 hover:shadow-primary/40 hover:scale-105 active:scale-95 transition-all">
     Export Intelligence
   </button>
 </div>
 <div className="premium-card overflow-hidden">
 <div className="overflow-x-auto">
 <table className="w-full text-left border-collapse">
 <thead className="bg-bgSoft/50 dark:bg-white/5 border-b border-accentGray/20">
 <tr>
 <th className="p-5 text-xs font-bold uppercase tracking-widest text-muted">Beneficiary</th>
 <th className="p-5 text-xs font-bold uppercase tracking-widest text-muted">ID Identifier</th>
 <th className="p-5 text-xs font-bold uppercase tracking-widest text-muted">Quantum</th>
 <th className="p-5 text-xs font-bold uppercase tracking-widest text-muted">State</th>
 <th className="p-5 text-xs font-bold uppercase tracking-widest text-muted">Hash ID</th>
 <th className="p-5 text-xs font-bold uppercase tracking-widest text-muted">Timestamp</th>
 </tr>
 </thead>
 <tbody className="divide-y divide-accentGray/10">
 {payments.map((p) => (
 <tr key={p.id} className="hover:bg-bgSoft/30 dark:hover:bg-white/5 transition-colors">
 <td className="p-5 font-semibold text-heading">{p.name}</td>
 <td className="p-5 text-muted font-mono text-xs">{p.user_id}</td>
 <td className="p-5 font-bold text-primary">â‚¹{p.amount}</td>
 <td className="p-5">
   <span className={`px-3 py-1 rounded-full text-xs font-bold ${
     p.status === 'success' ? 'bg-accent-green/10 text-accent-green' : 'bg-accent-red/10 text-accent-red'
   }`}>
     {p.status?.toUpperCase()}
   </span>
 </td>
 <td className="p-5 text-muted font-mono text-xs">{p.transaction_id}</td>
 <td className="p-5 text-muted text-sm">{new Date(p.created_at).toLocaleString()}</td>
 </tr>
 ))}
 </tbody>
 </table>
 </div>
 </div>
 </div>
 );
};

export default SuperPayments;



